<template>
    <div class="menuAdmin">
        <div class="menuCont">
            <my-tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="false"
                :treeToolBar="treeToolBar"
                :defaultProps="defaultProps"
                :nodeKey="'id'"
                @handleAddTreeNode="handleAddTreeNode"
                @handleTreeNodeClick="handleTreeNodeClick"
                :defaultExpandedKeys="defaultExpandedKeys"
                :btnName="btnName"
                treeSearchBar
            >
            </my-tree>
        </div>
        <div class="formCont">
            <el-form
                :model="addForm"
                ref="addForm"
                label-width="100px"
                :inline="true"
            >
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item
                            label="菜单名称"
                            :rules="[
                                { required: true, message: '请输入菜单名称' },
                            ]"
                            prop="name"
                        >
                            <el-input
                                clearable
                                placeholder="请输入菜单名称"
                                maxlength="20"
                                size="small"
                                v-model="addForm.name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="英文名称"
                            :rules="[{ message: '请输入英文名称' }]"
                            prop="name_en"
                        >
                            <el-input
                                clearable
                                placeholder="请输入英文名称"
                                maxlength="20"
                                size="small"
                                v-model="addForm.name_en"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="上级菜单" v-if="this.level > -1">
                            {{
                                this.addForm.parent_name
                                    ? this.addForm.parent_name
                                    : ""
                            }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="URL">
                            <el-input
                                clearable
                                placeholder="请输入URL"
                                maxlength="100"
                                size="small"
                                v-model="addForm.url"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="图标ICON"
                            v-if="this.level == 0 || this.level == 2"
                        >
                            <el-input
                                clearable
                                placeholder="请输入图标ICON"
                                maxlength="100"
                                size="small"
                                v-model="addForm.icon"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="this.level > 1">
                        <el-form-item label="按钮位置">
                            <el-radio v-model="addForm.type" :label="'table'"
                                >Table</el-radio
                            >
                            <el-radio v-model="addForm.type" :label="'action'"
                                >Action</el-radio
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="this.level > 1">
                        <el-form-item label="按钮功能类型">
                            <el-radio v-model="addForm.status_flag" :label="1"
                                >常规按钮</el-radio
                            >
                            <el-radio v-model="addForm.status_flag" :label="2"
                                >状态按钮（有原因）</el-radio
                            >
                            <el-radio v-model="addForm.status_flag" :label="3"
                                >状态按钮（无原因）</el-radio
                            >
                            <el-radio
                                v-model="addForm.status_flag"
                                v-show="addForm.type == 'table'"
                                :label="4"
                                >气泡确认框</el-radio
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="主题类名">
                            <el-input
                                clearable
                                placeholder="请输入主题类名"
                                maxlength="20"
                                size="small"
                                v-model="addForm.class"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="函数名称" v-if="this.level > 0">
                            <el-input
                                clearable
                                placeholder="请输入函数名称"
                                maxlength="100"
                                size="small"
                                v-model="addForm.funcName"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="level === 0">
                        <el-form-item label="二级分类">
                            <el-checkbox v-model="addForm.is_category" :true-label="1" :false-label="0"></el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-show="level === 1">
                        <el-form-item label="分类名称">
                            <el-select v-model="addForm.category" value-key="" placeholder="请选择分类" size="small" clearable filterable>
                                <el-option v-for="item in menuCategoryList"
                                    :key="item.id"
                                    :label="item.name_en"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="排序">
                            <el-input
                                clearable
                                placeholder="请输入排序"
                                maxlength="100"
                                size="small"
                                v-model="addForm.sort"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="模块状态" v-if="this.level >= 2">
                            <el-checkbox-group v-model="show_button">
                                <el-checkbox
                                    v-for="(item, index) in this
                                        .menuSelectStatusList"
                                    :key="index"
                                    :label="item.value"
                                    @change="checkboxChange"
                                    >{{ item.name }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="状态编辑"
                            v-if="this.level == 1"
                            class="status-edit-form-item"
                        >
                            <el-row
                                :gutter="0"
                                v-for="(item, index) in menuGetStatusList"
                                :key="index"
                            >
                                <el-col :span="4">
                                    <el-input
                                        size="small"
                                        placeholder="状态名"
                                        v-model="item.name"
                                    ></el-input>
                                </el-col>
                                <el-col :span="4">
                                    <el-input
                                        size="small"
                                        placeholder="状态英文名"
                                        v-model="item.name_en"
                                    ></el-input>
                                </el-col>
                                <el-col :span="4">
                                    <el-input
                                        size="small"
                                        placeholder="状态值"
                                        v-model="item.value"
                                    ></el-input>
                                </el-col>
                                <el-col :span="4">
                                    <el-input
                                        size="small"
                                        type="number"
                                        placeholder="排序"
                                        v-model="item.sort"
                                    ></el-input>
                                </el-col>
                                <el-col :span="3">
                                    <el-button
                                        type="text"
                                        size="mini"
                                        icon="el-icon-plus"
                                        @click="addItems"
                                    ></el-button>
                                    <el-button
                                        type="text"
                                        size="mini"
                                        icon="el-icon-minus"
                                        @click="minusItems(index)"
                                    ></el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="footer">
                <el-button @click="commit" type="primary" size="small"
                    >保 存</el-button
                >
                <el-button @click="clear" v-if="nowStatus" size="small"
                    >清 空</el-button
                >
                <el-button @click="del" type="danger" v-else size="small"
                    >删 除</el-button
                >
            </div>
        </div>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import Tree from "@/common/components/treeChange";

export default {
    data() {
        return {
            treeData: [],
            treeLoading: false,
            treeToolBar: true,
            defaultProps: {
                children: "child",
                label: "name",
            },
            btnName: "创建菜单",

            addForm: {
                name: "",
                parent_name: "",
                url: "",
                icon: "",
                type: "",
                funcName: "",
                sort: "",
                class: "",
                status_flag: 0,
                is_category: 0,
                category: null
            },
            show_button: [],
            parent_id: -1,
            nowStatus: false,
            level: 0,
            menuSelectStatusList: [],
            menuGetStatusList: [],
            emptyItem: {
                name: "",
                value: "",
                sort: "",
            },
            now_id: "",
            menuCategoryList: []
        };
    },
    methods: {
        getMenu(id) {
            this.treeLoading = true;
            this.defaultExpandedKeys = [id == 999999 ? 1 : id];
            cmofferApi.menu({}, "get", id).then((res) => {
                if (res) {
                    if (id) {
                        this.addForm = res.data;
                        this.show_button = res.data.show_button
                            ? res.data.show_button
                            : [];
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(id);
                        });
                    } else {
                        this.treeData = res.data;
                        this.$nextTick(() => {
                            this.$refs.myTree.$refs.tree.setCurrentKey(
                                this.addForm.id ? this.addForm.id : 0
                            );
                        });
                    }
                }
                this.treeLoading = false;
            });
        },
        handleAddTreeNode() {
            let lastForm = {};
            lastForm = JSON.parse(JSON.stringify(this.addForm));
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm.name = "";
            this.addForm.parent_name = lastForm.name;
            this.addForm.parent_id = lastForm.id;
            this.addForm.id = "";
            this.addForm.url = "";
            this.addForm.icon = "";
            this.addForm.type = "";
            this.addForm.funcName = "";
            this.addForm.sort = "";
            this.addForm.status_flag = 0;
            this.nowStatus = true;
            this.level = Number(this.level + 1);
            //   this.$nextTick(() => {
            // this.$refs.myTree.$refs.tree.setCurrentKey();
            //   });
        },
        clear() {
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.addForm.name = "";
            this.addForm.url = "";
            this.addForm.icon = "";
            this.addForm.type = "";
            this.addForm.funcName = "";
            this.addForm.sort = "";
            this.addForm.status_flag = 0;
        },
        handleTreeNodeClick(item) {
            this.now_id = item.id;
            this.level = item.level;
            this.parent_id = item.parent_id;
            this.nowStatus = false;
            this.menuSelectStatusList = [];
            this.menuGetStatusList = [];
            this.show_button = [];
            this.getMenu(item.id == 0 ? 999999 : item.id);
            if (item.level >= 2) {
                this.menuSelectStatus();
            } else if (item.level == 1) {
                this.menuGetStatus();
            }
        },
        commit() {
            this.treeLoading = true;
            if (this.level == 1) {
                this.menuSetStatus();
            }
            cmofferApi
                .menu(
                    {
                        ...this.addForm,
                        show_button: this.show_button,
                    },
                    "post",
                    this.addForm.id
                )
                .then((res) => {
                    if (res) {
                        if (res.errcode == 0) {
                            this.$message.success("保存成功");
                            this.getMenu();
                            this.getMenu(res.menu_id);
                            this.$store.dispatch("getMenuListByRoles");
                        }
                    }
                    this.treeLoading = false;
                });
        },
        menuSetStatus() {
            this.now_id && this.menuGetStatusList.length > 0 && cmofferApi.menuSetStatus(
                {
                    menu_id: this.now_id,
                    dataInfo: this.menuGetStatusList,
                },
                "post"
            );
        },
        del() {
            this.$confirm("确认删除此菜单？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.treeLoading = true;
                    cmofferApi
                        .menu({}, "delete", this.addForm.id)
                        .then((res) => {
                            if (res) {
                                if (res.code == 200) {
                                    this.$message.success("删除成功");
                                }
                                this.treeLoading = false;
                                this.getMenu();
                                this.getMenu(999999);
                                this.$store.dispatch("getMenuListByRoles");
                            }
                        });
                })
                .catch(() => {
                    this.$message.info("未删除");
                });
        },
        menuSelectStatus() {
            cmofferApi
                .menuSelectStatus(
                    {
                        menu_id: this.parent_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.menuSelectStatusList = res.data;
                    }
                });
        },
        menuGetStatus() {
            cmofferApi
                .menuGetStatus(
                    {
                        menu_id: this.now_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.menuGetStatusList = res.data.dataInfo
                            ? res.data.dataInfo
                            : [];
                        if (
                            this.menuGetStatusList &&
                            this.menuGetStatusList.length == 0
                        ) {
                            this.menuGetStatusList.push(
                                JSON.parse(JSON.stringify(this.emptyItem))
                            );
                        }
                    }
                });
        },
        addItems() {
            this.menuGetStatusList.push(
                JSON.parse(JSON.stringify(this.emptyItem))
            );
        },
        minusItems(index) {
            if (this.menuGetStatusList && this.menuGetStatusList.length > 1) {
                this.menuGetStatusList.splice(index, 1);
            }
        },
        menuSelectCategory(){
            cmofferApi.menuSelectCategory({}, "get").then(res=>{
              if(res){
                // console.log(res)
                this.menuCategoryList = res.data;
              }
            })
        }
    },

    created() {
        this.getMenu();
        this.getMenu(999999);
        this.menuSelectCategory();
    },
    components: {
        "my-tree": Tree,
    },
};
</script>
<style lang="scss">
.menuAdmin {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    .menuCont {
        width: 250px;
        box-sizing: border-box;
        height: calc(100% - 10px);
        border: 1px solid #eee;
        &:hover {
            box-shadow: 2px 2px 10px #eee;
        }
    }
    .formCont {
        width: calc(100% - 250px);
        padding: 20px;
        .el-col-24 {
            text-align: left;
        }
        .el-form-item__content {
            width: 500px;
        }
        .status-edit-form-item {
            .el-form-item__content {
                width: 700px;
                .el-col{
                    & + .el-col{
                        margin-left: 20px;
                    }
                }
            }
        }
        .el-input {
            max-width: 450px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
        .footer {
            text-align: left;
            margin: 30px 100px;
        }
    }
}
</style>